export class PayloadError {
    constructor(public mensaje: string, public stack: string) {}
}
